// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
@media (min-width: 1024px) {
  :host {
    height: 100%;
  }
}

ion-card {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
}
@media (max-width: 599px) {
  ion-card {
    min-height: 85vh;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  ion-card {
    height: auto;
    min-height: 85vh;
    overflow: visible;
  }
}
@media (min-width: 1024px) {
  ion-card {
    display: flex;
    flex-direction: column;
  }
}

.card-header {
  height: 5vh;
  max-height: 5vh;
  min-height: 0 !important;
  display: flex;
  align-items: center;
  padding: var(--spacing-large) var(--spacing-small);
  color: white !important;
  border-left: 5px solid var(--ion-color-primary);
  background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;
}

.header-content {
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
}

.drone-title {
  font-weight: bold;
  left: var(--spacing-small);
  width: auto;
  color: var(--ion-color-primary) !important;
}
@media (max-width: 599px) {
  .drone-title {
    font-size: clamp(0.65rem, 1.3vw, 0.85rem);
    line-height: 1.1;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .drone-title {
    font-size: clamp(0.75rem, 1.2vw, 0.95rem);
  }
}
@media (min-width: 1024px) {
  .drone-title {
    font-size: clamp(0.85rem, 1vw, 1.1rem);
  }
}

.time-filter {
  position: absolute;
  z-index: 990;
  width: 70%;
  height: 100%;
  right: var(--spacing-small);
  margin-right: var(--spacing-large);
}

.card-content {
  height: 85%;
  padding: 0;
  overflow: hidden;
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-content {
    height: auto;
    overflow: visible;
  }
}
@media (min-width: 1024px) {
  .card-content {
    flex: 1;
    min-height: 0;
    height: auto;
  }
}

.drone-summary-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: var(--spacing-small);
  padding-right: var(--spacing-large);
  overflow-y: auto;
  min-width: 0;
}
@media (max-width: 599px) {
  .drone-summary-container {
    padding-right: var(--spacing-small);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .drone-summary-container {
    height: auto;
    overflow-y: auto;
    padding-right: var(--spacing-small);
  }
}
@media (min-width: 1024px) {
  .drone-summary-container {
    flex: 1;
    min-height: 0;
    flex-direction: row;
    padding: var(--spacing-medium);
    gap: var(--spacing-small);
    align-items: stretch;
    overflow: hidden;
  }
}

/* Battery Usage Chart Section */
.battery-chart-section {
  width: 100%;
  min-width: 0;
}
@media (max-width: 599px) {
  .battery-chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .battery-chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 1024px) {
  .battery-chart-section {
    min-height: auto;
    height: auto;
    flex: 1.35 1 0;
    width: auto;
    margin-right: 0;
  }
}

/* Info Cards Section: 4 cards layout */
.info-cards-section {
  display: grid;
  gap: var(--spacing-small);
  width: 100%;
  min-width: 0;
}
@media (max-width: 599px) {
  .info-cards-section {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .info-cards-section {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 1024px) {
  .info-cards-section {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-auto-rows: 1fr;
    gap: var(--spacing-xs);
    flex: 1.05 1 0;
    width: auto;
    height: auto;
    margin-right: 0;
  }
}

/* Pilots Chart Section: Operations by Pilot */
.pilots-chart-section {
  width: 100%;
  grid-column: 1/-1;
  margin-top: var(--spacing-medium);
  min-width: 0;
}
@media (max-width: 599px) {
  .pilots-chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .pilots-chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 1024px) {
  .pilots-chart-section {
    min-height: auto;
    height: auto;
    flex: 1.35 1 0;
    width: auto;
    margin-right: 0;
  }
}

/* Operations Section: Last Operations */
.operations-section {
  width: 100%;
  display: flex;
  min-width: 0;
}
@media (max-width: 599px) {
  .operations-section {
    min-height: 150px;
    flex: 0 0 auto;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .operations-section {
    min-height: 150px;
    flex: 0 0 auto;
  }
}
@media (min-width: 1024px) {
  .operations-section {
    flex: 1.05 1 0;
    height: auto;
    width: auto;
  }
}

.chart-container {
  height: 100%;
  width: 100%;
  margin: 0;
}

.top-summary-card {
  height: 50%;
  padding-bottom: var(--spacing-xx-small);
  margin: 0 !important;
}

.bottom-summary-card {
  height: 50%;
  padding-top: var(--spacing-xx-small);
  margin: 0 !important;
}

.card-title-label {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ion-color-primary);
  text-align: center;
  font-weight: 500;
}
@media (max-width: 599px) {
  .card-title-label {
    font-size: clamp(0.7rem, 1.6vmin, 0.85rem);
    line-height: 1.1;
    text-align: center;
    flex: 0 0 auto;
    padding: 0 var(--spacing-xs);
    margin-right: auto;
    margin-left: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-title-label {
    font-size: clamp(0.75rem, 1.3vmin, 0.95rem);
  }
}
@media (min-width: 1024px) {
  .card-title-label {
    font-size: clamp(0.85rem, 1.1vmin, 1.1rem);
  }
}

.card-content-label {
  display: flex !important;
  text-align: center;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
  font-weight: 600;
}
@media (max-width: 599px) {
  .card-content-label {
    font-size: clamp(0.65rem, 1.5vmin, 0.8rem);
    line-height: 1.1;
    justify-content: flex-end !important;
    flex: 0 0 auto !important;
    text-align: right;
    min-width: 0;
    max-width: 45% !important;
    padding: 0 var(--spacing-xs);
    margin-right: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-content-label {
    font-size: clamp(0.7rem, 1.2vmin, 0.9rem);
  }
}
@media (min-width: 1024px) {
  .card-content-label {
    font-size: clamp(0.95rem, 2vmin, 1.3rem);
  }
}

.info-card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin: 0;
  padding: var(--spacing-xs);
  overflow: hidden;
  border-radius: var(--border-radius-small);
  background-color: rgba(0, 0, 0, 0.02);
}
@media (max-width: 599px) {
  .info-card-content {
    padding: var(--spacing-small);
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 45px;
    gap: var(--spacing-xs);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .info-card-content {
    padding: var(--spacing-small);
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 45px;
    gap: var(--spacing-xs);
  }
}
@media (min-width: 1024px) {
  .info-card-content {
    padding: var(--spacing-small);
  }
}

.operations-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}
@media (max-width: 599px) {
  .operations-card {
    height: auto;
    min-height: 180px;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .operations-card {
    height: auto;
    min-height: 180px;
  }
}

.operations-list-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.last-operations-info-label {
  display: block;
  text-align: center;
  color: var(--ion-color-dark);
  --color: var(--ion-color-dark);
  padding: var(--spacing-xs);
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.03);
  min-height: auto;
}
@media (max-width: 599px) {
  .last-operations-info-label {
    font-size: clamp(0.5rem, 1.2vmin, 0.65rem);
    line-height: 1;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .last-operations-info-label {
    font-size: clamp(0.6rem, 0.95vmin, 0.7rem);
  }
}
@media (min-width: 1024px) {
  .last-operations-info-label {
    font-size: clamp(0.65rem, 0.8vmin, 0.75rem);
  }
}
.last-operations-info-label ion-label {
  color: var(--ion-color-dark);
  display: block;
  word-break: break-word;
}

/* Legacy grid styles - removed in favor of new responsive flex layout */
.hidden {
  display: none;
}

.card-container-no-summary,
.card-container-summary {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  height: 100%;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.card-container-summary > * {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

/** Media queries are now handled by mocca-breakpoints mixins above **/`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/log-summaries/drone-summary/drone-summary.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;ACqCE;EDrCF;IAIQ,YAAA;EAAN;AACF;;AAGA;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;ACUE;EDfF;IAQQ,gBAAA;EACN;AACF;ACYE;EDtBF;IAYQ,YAAA;IACA,gBAAA;IACA,iBAAA;EAEN;AACF;ACYE;ED7BF;IAkBQ,aAAA;IACA,sBAAA;EAGN;AACF;;AAAA;EACI,WAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,kDAAA;EACA,uBAAA;EACA,+CAAA;EACA,8JAAA;AAGJ;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,0BAAA;EACA,WAAA;EACA,0CAAA;AAGJ;ACjCE;ED0BF;IAOQ,yCAAA;IACA,gBAAA;EAIN;AACF;AChCE;EDmBF;IAYQ,yCAAA;EAKN;AACF;AC9BE;EDYF;IAgBQ,sCAAA;EAMN;AACF;;AAHA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,kCAAA;AAMJ;;AAHA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;AAMJ;ACzDE;EDgDF;IAMQ,YAAA;IACA,iBAAA;EAON;AACF;ACxDE;EDyCF;IAWQ,OAAA;IACA,aAAA;IACA,YAAA;EAQN;AACF;;AALA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,mCAAA;EACA,gBAAA;EACA,YAAA;AAQJ;AC1FE;EDwEF;IAaQ,mCAAA;EASN;AACF;ACxFE;EDiEF;IAiBQ,YAAA;IACA,gBAAA;IACA,mCAAA;EAUN;AACF;ACxFE;ED0DF;IAuBQ,OAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,yBAAA;IACA,oBAAA;IACA,gBAAA;EAWN;AACF;;AARA,gCAAA;AACA;EACI,WAAA;EACA,YAAA;AAWJ;ACvHE;ED0GF;IAKQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EAYN;AACF;ACzHE;EDmGF;IAaQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EAaN;AACF;AC3HE;ED4FF;IAqBQ,gBAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,eAAA;EAcN;AACF;;AAXA,uCAAA;AACA;EACI,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAcJ;AC1JE;EDwIF;IAOQ,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAeN;AACF;AC7JE;EDiIF;IAgBQ,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAgBN;AACF;AChKE;ED0HF;IAyBQ,8BAAA;IACA,2BAAA;IACA,mBAAA;IACA,sBAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EAiBN;AACF;;AAdA,8CAAA;AACA;EACI,WAAA;EACA,iBAAA;EACA,iCAAA;EACA,YAAA;AAiBJ;AClME;ED6KF;IAOQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EAkBN;AACF;ACpME;EDsKF;IAeQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EAmBN;AACF;ACtME;ED+JF;IAuBQ,gBAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,eAAA;EAoBN;AACF;;AAjBA,wCAAA;AACA;EACI,WAAA;EACA,aAAA;EACA,YAAA;AAoBJ;ACpOE;ED6MF;IAMQ,iBAAA;IACA,cAAA;EAqBN;AACF;ACnOE;EDsMF;IAWQ,iBAAA;IACA,cAAA;EAsBN;AACF;AClOE;ED+LF;IAgBQ,cAAA;IACA,YAAA;IACA,WAAA;EAuBN;AACF;;AApBA;EACI,YAAA;EACA,WAAA;EACA,SAAA;AAuBJ;;AApBA;EACI,WAAA;EACA,uCAAA;EACA,oBAAA;AAuBJ;;AApBA;EACI,WAAA;EACA,oCAAA;EACA,oBAAA;AAuBJ;;AApBA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAuBJ;AClRE;EDqPF;IASQ,0CAAA;IACA,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,4BAAA;IACA,kBAAA;IACA,kCAAA;EAwBN;AACF;ACtRE;ED8OF;IAmBQ,2CAAA;EAyBN;AACF;ACpRE;EDuOF;IAuBQ,0CAAA;EA0BN;AACF;;AAvBA;EACI,wBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AA0BJ;AChTE;EDgRF;IASQ,0CAAA;IACA,gBAAA;IACA,oCAAA;IACA,yBAAA;IACA,iBAAA;IACA,YAAA;IACA,yBAAA;IACA,4BAAA;IACA,mCAAA;EA2BN;AACF;ACtTE;EDyQF;IAqBQ,yCAAA;EA4BN;AACF;ACpTE;EDkQF;IAyBQ,wCAAA;EA6BN;AACF;;AA1BA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,yCAAA;EACA,qCAAA;AA6BJ;ACnVE;ED6SF;IAYQ,6BAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EA8BN;AACF;ACvVE;EDsSF;IAsBQ,6BAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EA+BN;AACF;AC3VE;ED+RF;IAgCQ,6BAAA;EAgCN;AACF;;AA7BA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AAgCJ;ACrXE;EDiVF;IAOQ,YAAA;IACA,iBAAA;EAiCN;AACF;ACpXE;ED0UF;IAYQ,YAAA;IACA,iBAAA;EAkCN;AACF;;AA/BA;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAkCJ;;AA/BA;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;AAkCJ;ACpZE;ED0WF;IAWQ,0CAAA;IACA,cAAA;EAmCN;AACF;ACnZE;EDmWF;IAgBQ,0CAAA;EAoCN;AACF;ACjZE;ED4VF;IAoBQ,2CAAA;EAqCN;AACF;AAnCI;EACE,4BAAA;EACA,cAAA;EACA,sBAAA;AAqCN;;AAjCA,wEAAA;AAEA;EACI,aAAA;AAmCJ;;AAhCA;;EAEI,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAmCJ;;AAhCA;EACI,WAAA;EACA,eAAA;EACA,YAAA;AAmCJ;;AAhCA,sEAAA","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n\r\n:host {\r\n    display: block;\r\n\r\n    @include bp.desktop {\r\n        height: 100%;\r\n    }\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n\r\n    @include bp.mobile {\r\n        min-height: 85vh;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        min-height: 85vh;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n.card-header {\r\n    height: 5vh;\r\n    max-height: 5vh;\r\n    min-height: 0 !important;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: var(--spacing-large) var(--spacing-small);\r\n    color: white !important;\r\n    border-left: 5px solid var(--ion-color-primary);\r\n    background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-small);\r\n}\r\n\r\n.drone-title {\r\n    font-weight: bold;\r\n    left: var(--spacing-small);\r\n    width: auto;\r\n    color: var(--ion-color-primary) !important;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.65rem, 1.3vw, 0.85rem);\r\n        line-height: 1.1;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.75rem, 1.2vw, 0.95rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.85rem, 1vw, 1.1rem);\r\n    }\r\n}\r\n\r\n.time-filter {\r\n    position: absolute;\r\n    z-index: 990;\r\n    width: 70%;\r\n    height: 100%;\r\n    right: var(--spacing-small);\r\n    margin-right: var(--spacing-large);\r\n}\r\n\r\n.card-content {\r\n    height: 85%;\r\n    padding: 0;\r\n    overflow: hidden;\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1;\r\n        min-height: 0;\r\n        height: auto;\r\n    }\r\n}\r\n\r\n.drone-summary-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n    padding: var(--spacing-small);\r\n    padding-right: var(--spacing-large);\r\n    overflow-y: auto;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        padding-right: var(--spacing-small);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        overflow-y: auto;\r\n        padding-right: var(--spacing-small);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1;\r\n        min-height: 0;\r\n        flex-direction: row;\r\n        padding: var(--spacing-medium);\r\n        gap: var(--spacing-small);\r\n        align-items: stretch;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n/* Battery Usage Chart Section */\r\n.battery-chart-section {\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        min-height: auto;\r\n        height: auto;\r\n        flex: 1.35 1 0;\r\n        width: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Info Cards Section: 4 cards layout */\r\n.info-cards-section {\r\n    display: grid;\r\n    gap: var(--spacing-small);\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        grid-template-columns: 1fr;\r\n        grid-auto-rows: auto;\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        grid-template-columns: 1fr;\r\n        grid-auto-rows: auto;\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        grid-template-columns: 1fr 1fr;\r\n        grid-template-rows: 1fr 1fr;\r\n        grid-auto-rows: 1fr;\r\n        gap: var(--spacing-xs);\r\n        flex: 1.05 1 0;\r\n        width: auto;\r\n        height: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Pilots Chart Section: Operations by Pilot */\r\n.pilots-chart-section {\r\n    width: 100%;\r\n    grid-column: 1 / -1;\r\n    margin-top: var(--spacing-medium);\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        min-height: auto;\r\n        height: auto;\r\n        flex: 1.35 1 0;\r\n        width: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Operations Section: Last Operations */\r\n.operations-section {\r\n    width: 100%;\r\n    display: flex;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        min-height: 150px;\r\n        flex: 0 0 auto;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        min-height: 150px;\r\n        flex: 0 0 auto;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1.05 1 0;\r\n        height: auto;\r\n        width: auto;\r\n    }\r\n}\r\n\r\n.chart-container {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0;\r\n}\r\n\r\n.top-summary-card {\r\n    height: 50%;\r\n    padding-bottom: var(--spacing-xx-small);\r\n    margin: 0 !important;\r\n}\r\n\r\n.bottom-summary-card {\r\n    height: 50%;\r\n    padding-top: var(--spacing-xx-small);\r\n    margin: 0 !important;\r\n}\r\n\r\n.card-title-label {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--ion-color-primary);\r\n    text-align: center;\r\n    font-weight: 500;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.7rem, 1.6vmin, 0.85rem);\r\n        line-height: 1.1;\r\n        text-align: center;\r\n        flex: 0 0 auto;\r\n        padding: 0 var(--spacing-xs);\r\n        margin-right: auto;\r\n        margin-left: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.75rem, 1.3vmin, 0.95rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.85rem, 1.1vmin, 1.1rem);\r\n    }\r\n}\r\n\r\n.card-content-label {\r\n    display: flex !important;\r\n    text-align: center;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    width: 100%;\r\n    font-weight: 600;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.65rem, 1.5vmin, 0.8rem);\r\n        line-height: 1.1;\r\n        justify-content: flex-end !important;\r\n        flex: 0 0 auto !important;\r\n        text-align: right;\r\n        min-width: 0;\r\n        max-width: 45% !important;\r\n        padding: 0 var(--spacing-xs);\r\n        margin-right: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.7rem, 1.2vmin, 0.9rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.95rem, 2vmin, 1.3rem);\r\n    }\r\n}\r\n\r\n.info-card-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: var(--spacing-xs);\r\n    overflow: hidden;\r\n    border-radius: var(--border-radius-small);\r\n    background-color: rgba(0, 0, 0, 0.02);\r\n\r\n    @include bp.mobile {\r\n        padding: var(--spacing-small);\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: auto;\r\n        min-height: 45px;\r\n        gap: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        padding: var(--spacing-small);\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: auto;\r\n        min-height: 45px;\r\n        gap: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        padding: var(--spacing-small);\r\n    }\r\n}\r\n\r\n.operations-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    height: 100%;\r\n\r\n    @include bp.mobile {\r\n        height: auto;\r\n        min-height: 180px;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        min-height: 180px;\r\n    }\r\n}\r\n\r\n.operations-list-container {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: var(--spacing-xs);\r\n}\r\n\r\n.last-operations-info-label {\r\n    display: block;\r\n    text-align: center;\r\n    color: var(--ion-color-dark);\r\n    --color: var(--ion-color-dark);\r\n    padding: var(--spacing-xs);\r\n    border-radius: 4px;\r\n    background-color: rgba(0, 0, 0, 0.03);\r\n    min-height: auto;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.5rem, 1.2vmin, 0.65rem);\r\n        line-height: 1;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.6rem, 0.95vmin, 0.7rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.65rem, 0.8vmin, 0.75rem);\r\n    }\r\n\r\n    ion-label {\r\n      color: var(--ion-color-dark);\r\n      display: block;\r\n      word-break: break-word;\r\n    }\r\n}\r\n\r\n/* Legacy grid styles - removed in favor of new responsive flex layout */\r\n\r\n.hidden {\r\n    display: none;\r\n}\r\n\r\n.card-container-no-summary,\r\n.card-container-summary {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.card-container-summary > * {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n}\r\n\r\n/** Media queries are now handled by mocca-breakpoints mixins above **/\r\n","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
